import {XauditModel} from '../xaudit.model';
import {ContactDataModel} from '../person/contact-data.model';

export class PatientContactDataModel extends XauditModel {
  ContactId: string;
  PatientId: string;
  dataContact: ContactDataModel;
  enumPatientContactTypeID: string;
}
